import { Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  CmsDataService,
  CmsProductItem,
} from '../../services/cms-data.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-productos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './productos.component.html',
  styleUrl: './productos.component.scss',
})
export class ProductosComponent {
  private cmsData = inject(CmsDataService);
  private router = inject(Router);
  private langService = inject(LanguageService);

  items: CmsProductItem[] = [];
  isLoading = true;

  constructor() {
    // Idioma del switcher runtime (no LOCALE_ID del build). Recarga al cambiar.
    effect(() => {
      const lang = this.langService.currentLang();
      void this.load(lang);
    });
  }

  private async load(lang: string): Promise<void> {
    this.isLoading = true;
    this.items = await this.cmsData.getCmsItems('productos', lang);
    this.isLoading = false;
  }

  pay(item: CmsProductItem): void {
    const params: Record<string, string> = { concept: item.title };
    if (item.price) params['amount'] = item.price;
    this.router.navigate(['/pago-libre'], { queryParams: params });
  }
}
